import { Component, ElementRef, HostBinding, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import {
  CmsComponent,
  EventService,
  OCC_USER_ID_CURRENT,
  TranslationService,
  UserIdService,
  WindowRef,
} from '@spartacus/core';
import { CmsComponentData, CurrentProductService, ProductIntroComponent } from '@spartacus/storefront';
import { BehaviorSubject, map, Subscription } from 'rxjs';
import { ToolsService } from '../../../../core/services/tools.service';
import { DEVICE_SIZE } from '../../../../core/models/others.model';

@Component({
  selector: 'cx-product-intro',
  templateUrl: './product-intro.component.html',
  styleUrl: './product-intro.component.scss',
  standalone: false,
})
export class CustomProductIntroComponent extends ProductIntroComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = '';

  DEVICE_SIZE = DEVICE_SIZE;
  subscription = new Subscription();
  component$ = new BehaviorSubject<CmsComponent | undefined>(undefined);
  displayComponent$ = new BehaviorSubject<boolean>(true);
  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));

  constructor(
    protected _currentProductService: CurrentProductService,
    protected _translationService: TranslationService,
    protected _winRef: WindowRef,
    protected _eventService: EventService,
    private componentData: CmsComponentData<CmsComponent>,
    private toolsService: ToolsService,
    private el: ElementRef,
    private renderer: Renderer2,
    private userIdService: UserIdService,
  ) {
    super(_currentProductService, _translationService, _winRef, _eventService);
  }

  ngOnInit(): void {
    this.getComponent();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getComponent() {
    this.subscription.add(
      this.componentData.data$.subscribe(component => {
        this.component$.next(component);
        this.checkStateComponent();
      }),
    );
  }

  removeHost() {
    const hostElement = this.el.nativeElement;
    this.renderer.removeChild(hostElement.parentNode, hostElement);
  }

  @HostListener('window:resize') resize() {
    this.checkStateComponent();
  }

  checkStateComponent() {
    const component = this.component$.getValue()!;
    const limitSize = 1300;

    if (component.styleClasses === 'productName_01') {
      this.displayComponent$.next(this.toolsService.getSizeScreen().width < limitSize);
      this.hostClass = this.toolsService.getSizeScreen().width < limitSize ? '' : 'd-none';
    }

    if (component.styleClasses === 'productName_02') {
      this.displayComponent$.next(this.toolsService.getSizeScreen().width >= limitSize);
      this.hostClass = this.toolsService.getSizeScreen().width >= limitSize ? '' : 'd-none';
    }
  }
}
